import React from "react";
import { Label, FormGroup, Input } from "reactstrap";
import CustomSelect from "../../CommonElements/CustomSelect";

// ===== Reusable UI Wrapper Components =====
const labelStyle = {
  fontSize: "0.85rem",
  fontWeight: 600,
  color: "#555",
  marginBottom: "6px",
};

const SelectFormField = ({
  label,
  field,
  fieldName,
  errors,
  colSize = "4",
  required = true,
  onChange,
  ...selectProps
}) => (
  <FormGroup className={`col-lg-${colSize}`}>
    <Label style={labelStyle}>
      {label} {required && <span className="text-danger">*</span>}
    </Label>
    <CustomSelect
      value={field.value}
      onChange={onChange || field.onChange}
      className={errors[fieldName] ? "is-invalid" : ""}
      {...selectProps}
    />
    {errors[fieldName] && (
      <span className="text-danger">{errors[fieldName].message}</span>
    )}
  </FormGroup>
);

const InputFormField = ({
  label,
  field,
  fieldName,
  errors,
  colSize = "3",
  required = true,
  ...inputProps
}) => (
  <FormGroup className={`col-lg-${colSize}`}>
    <Label style={labelStyle}>
      {label} {required && <span className="text-danger">*</span>}
    </Label>
    <Input
      className="form-control"
      value={field.value}
      onChange={field.onChange}
      invalid={!!errors[fieldName]}
      {...inputProps}
    />
    {errors[fieldName] && (
      <span className="text-danger">{errors[fieldName].message}</span>
    )}
  </FormGroup>
);

export { SelectFormField, InputFormField };
